module.exports = __webpack_public_path__ + "ee95ff74aaf241adcfb903bc124ae26f.jpg";